export const FEEDBACK_ASSIST_HEADER_SCRIPT_ID = 'feedback-assist-header-script';
